import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initSentry, SentryErrorBoundary } from "@/sentry";

// Initialize Sentry before rendering so unhandled errors in the tree are captured.
initSentry();

function CrashFallback({ resetError }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="brutal-card p-8 max-w-md w-full text-center space-y-4" data-testid="sentry-crash-fallback">
        <h1 className="font-heading text-2xl md:text-3xl">SOMETHING BROKE</h1>
        <p className="text-sm text-muted-foreground">
          The app hit an unexpected error and our team has been notified.
          You can try again or reload the page.
        </p>
        <button
          data-testid="sentry-reset-btn"
          onClick={resetError}
          className="btn-primary w-full"
        >
          Try Again
        </button>
      </div>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SentryErrorBoundary fallback={CrashFallback} showDialog={false}>
      <App />
    </SentryErrorBoundary>
  </React.StrictMode>,
);
